import { IDocumentoTemplateBody } from "../../../../Interfaces/Geral/GestaoDeCadastro/Documentos/DocumentosInterface";
import {
    AtualizarDocumentoTemplateService,
    CadastrarDocumentoTemplateService,
    ListarDocumentosTemplateService,
} from "../../../../Services/Geral/GestaoDeCadastros/DocumentosTemplate/DocumentosTemplateServices";
import { Controller } from "../../../Controller";

export async function ListarDocumentosTemplateController() {
    return Controller(ListarDocumentosTemplateService());
}

export async function CadastrarDocumentoTemplateController(
    requestBody: IDocumentoTemplateBody
) {
    return Controller(CadastrarDocumentoTemplateService(requestBody));
}

export async function AtualizarDocumentoTemplateController(
    requestBody: IDocumentoTemplateBody
) {
    return Controller(AtualizarDocumentoTemplateService(requestBody));
}
